/* Glamorush Free Delivery Nudge - safe, no prototype overrides */
(function(){
  try{
    var FREE = 300000; /* PKR 3000 in paisa */
    var MAX_PILLS = 4;
    var cartTotal = 0; /* paisa already in the cart */
    var currentPrice = 0;

    function esc(s){
      return String(s).replace(/[&<>"']/g,function(c){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]; });
    }

    /* ---- Update nudge bar for this product's price plus what is already in the cart ---- */
    function updateNudge(priceInPaisa){
      try{
        var wrap = document.getElementById('gr-nudge-wrap');
        if(!wrap) return;
        if(priceInPaisa) currentPrice = priceInPaisa;
        var fill = document.getElementById('gr-nudge-fill');
        var truck = document.getElementById('gr-nudge-truck');
        var amtEl = document.getElementById('gr-nudge-amt');
        if(!fill||!truck||!amtEl) return;
        var total = currentPrice + cartTotal;
        var needed = FREE - total;
        var pct = Math.min(Math.round((total/FREE)*100),100);
        fill.style.width = pct+'%';
        truck.style.left = pct+'%';
        if(needed > 0){
          var pkr = Math.ceil(needed/100);
          amtEl.textContent = 'PKR '+pkr.toLocaleString();
        } else {
          /* Order qualifies — swap bar for success message */
          var bw = wrap.querySelector('.gr-nudge__bar-wrap');
          if(bw){
            bw.outerHTML = '<div class="gr-nudge__unlocked"><span class="gr-nudge__tick">&#10003;</span><span>'+
              (cartTotal > 0 ? 'Add this to your cart and your order gets <strong>FREE delivery!</strong>' : 'This product qualifies for <strong>FREE delivery!</strong>')+
              '</span></div>';
          }
        }
      }catch(e){}
    }

    function firstAvailable(p){
      var vs = p.variants||[];
      for(var i=0;i<vs.length;i++){ if(vs[i].available) return vs[i]; }
      return null;
    }

    /* ---- Suggest in-stock add-ons (related products first, cheapest first) ---- */
    function loadSuggestions(){
      try{
        var pillsEl = document.getElementById('gr-nudge-pills');
        var wrap = document.getElementById('gr-nudge-wrap');
        if(!pillsEl||!wrap) return;
        if(FREE - currentPrice - cartTotal <= 0) return;
        var pid = wrap.dataset.productId;
        var url = pid ? '/recommendations/products.json?product_id='+pid+'&limit=10' : '/collections/all/products.json?limit=12';

        fetch(url)
          .then(function(r){ return r.json(); })
          .then(function(data){
            try{
              var products = (data.products||[]).map(function(p){
                var v = firstAvailable(p);
                if(!v) return null;
                /* recommendations return price in paisa, products.json as "1500.00" */
                var paisa = typeof v.price === 'number' ? v.price : Math.round(parseFloat(v.price)*100);
                return { p: p, v: v, paisa: paisa };
              }).filter(function(x){
                return x && x.paisa > 0 && String(x.p.id) !== String(pid);
              }).sort(function(a,b){ return a.paisa - b.paisa; }).slice(0,MAX_PILLS);

              pillsEl.innerHTML = '';
              if(products.length === 0){
                var sg = document.getElementById('gr-nudge-suggest');
                if(sg) sg.style.display='none';
                return;
              }

              products.forEach(function(x){
                try{
                  var p = x.p;
                  var img = p.featured_image || (p.images && p.images[0] && (p.images[0].src || p.images[0]));
                  var imgSrc = img ? (img.indexOf('//')===0 ? 'https:'+img : img) : '';
                  if(imgSrc) imgSrc += (imgSrc.indexOf('?')>-1 ? '&' : '?')+'width=64';
                  var short = p.title.length>22 ? p.title.substring(0,22)+'...' : p.title;
                  var pill = document.createElement('a');
                  pill.className = 'gr-nudge__pill';
                  pill.href = '/products/'+p.handle;
                  pill.title = 'Add '+p.title;
                  pill.innerHTML =
                    (imgSrc ? '<img src="'+esc(imgSrc)+'" alt="" width="28" height="28" loading="lazy">' : '')+
                    '<span>'+esc(short)+'</span>'+
                    '<span class="gr-nudge__pill-price">PKR '+Math.round(x.paisa/100).toLocaleString()+'</span>'+
                    '<span class="gr-nudge__pill-add" role="button" aria-label="Add '+esc(p.title)+' to cart">+</span>';

                  pill.querySelector('.gr-nudge__pill-add').addEventListener('click',function(e){
                    try{
                      e.preventDefault();
                      e.stopPropagation();
                      var addBtn = this;
                      addBtn.textContent = '...';
                      fetch('/cart/add.js',{
                        method:'POST',
                        headers:{'Content-Type':'application/json','X-Requested-With':'XMLHttpRequest'},
                        body:JSON.stringify({id:x.v.id,quantity:1})
                      }).then(function(r){
                        if(r.ok){
                          addBtn.textContent = '✓';
                          addBtn.style.background='#27ae60';
                          cartTotal += x.paisa;
                          updateNudge();
                          /* Kalles: re-render and open the mini cart */
                          document.dispatchEvent(new CustomEvent('cart:refresh:opend'));
                        } else {
                          addBtn.textContent = '+';
                        }
                      }).catch(function(){
                        addBtn.textContent = '+';
                      });
                    }catch(ex){}
                  });

                  pillsEl.appendChild(pill);
                }catch(ex){}
              });
            }catch(ex){}
          }).catch(function(){});
      }catch(e){}
    }

    /* ---- Listen for variant changes from theme ---- */
    function listenVariantChange(){
      try{
        /* Kalles triggers a jQuery "variant:changed" event (price in paisa) on the product container */
        var $ = window.jQuery_T4NT;
        var wrap = document.getElementById('gr-nudge-wrap');
        var sec = wrap && wrap.closest('[id^="shopify-section-"]');
        if($){
          $(document).on('variant:changed',function(e){
            try{
              if(sec && e.target && !sec.contains(e.target)) return; /* ignore quick view / other products */
              if(e.currentVariant && e.currentVariant.price) updateNudge(e.currentVariant.price);
            }catch(ex){}
          });
        }

        var sel = document.querySelector('select[name="id"]');
        if(sel){
          sel.addEventListener('change',function(){
            try{
              var opt = sel.options[sel.selectedIndex];
              if(opt){
                var json = document.querySelector('.pr_variants_json');
                if(json){
                  var variants = JSON.parse(json.textContent||'[]');
                  var v = variants.find(function(vv){ return String(vv.id)===opt.value; });
                  if(v) updateNudge(v.price);
                }
              }
            }catch(ex){}
          });
        }
      }catch(e){}
    }

    /* ---- INIT ---- */
    function init(){
      try{
        var wrap = document.getElementById('gr-nudge-wrap');
        if(!wrap) return;
        currentPrice = parseInt(wrap.dataset.price||'0',10);
        updateNudge();
        listenVariantChange();
        fetch('/cart.js').then(function(r){ return r.json(); }).then(function(c){
          cartTotal = c.total_price||0;
          /* the product itself may already be in the cart: don't count it twice */
          (c.items||[]).forEach(function(it){
            if(String(it.product_id) === String(wrap.dataset.productId)) cartTotal -= it.final_line_price||0;
          });
          if(cartTotal < 0) cartTotal = 0;
          updateNudge();
        }).catch(function(){}).then(loadSuggestions);
      }catch(e){}
    }

    if(document.readyState==='loading'){
      document.addEventListener('DOMContentLoaded',init);
    } else {
      init();
    }
  }catch(e){}
}());
